module.exports = __webpack_public_path__ + "static/media/export.7520e7f1.svg";